import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62e5e39e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "watremarks-edit__workarea"
}
const _hoisted_2 = { class: "watremarks-edit__workarea__container" }
const _hoisted_3 = { class: "watremarks-edit__workarea__data" }
const _hoisted_4 = { class: "watremarks-edit__workarea__actions" }

import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services/index';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Watermarks',
  setup(__props) {

const busError = useEventBus<string>('toast-error');

const { t } = useI18n();

const { isMobile } = storeToRefs(useCommonStore());

const { generateImage } = useServicesStore();

const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());

const generationLoading = ref<boolean>(false);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const isEdit = ref<boolean>(false);

// const imageSize = computed(() => getBase64Size(imageForActions.value));

const removeBackgroundFileHandler = (): void => {
  generationLoading.value = true;
  generateImage({
    action: 'watermarks',
    image: removeBase64Prefix(imageForActions.value),
    params: {},
  })
    .then((res) => {
      imagePrev.value = imageForActions.value;
      imageResult.value = `data:image/png;base64,${res.image}`;
    })
    .catch((e) => {
      busError.emit(e?.message || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
    };
    img.src = imageForActions.value;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, { key: 0 }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["service__container watremarks", { 'service__container--mobile': _unref(isMobile) }])
        }, [
          (isEdit.value)
            ? (_openBlock(), _createBlock(ImageFinetune, {
                key: 0,
                class: "watermarks-edit__finetune",
                src: _unref(imageForActions),
                onReset: _cache[0] || (_cache[0] = ($event: any) => (isEdit.value = false)),
                onSave: editHandler,
                actions: ['reset', 'save']
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(AiCard, {
                  radius: 16,
                  class: "watremarks-edit__workarea__card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_img, {
                        src: _unref(imageForActions),
                        class: "watremarks-edit__workarea__image"
                      }, null, 8, ["src"]),
                      (generationLoading.value)
                        ? (_openBlock(), _createBlock(AiDropLoader, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_spacer),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(AiButton, {
                          theme: "dark",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (isEdit.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.correction')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(AiButton, {
                          theme: "dark",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (imageForActions.value = ''))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                          ]),
                          _: 1
                        }),
                        (!_unref(isMobile))
                          ? (_openBlock(), _createBlock(AiButton, {
                              key: 0,
                              disabled: generationLoading.value,
                              theme: "gradient-primary",
                              class: "watremarks-edit__workarea__button",
                              onClick: removeBackgroundFileHandler
                            }, {
                              default: _withCtx(() => [
                                (!generationLoading.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('watremarks.watremarks')), 1)
                                    ], 64))
                                  : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_unref(isMobile))
                      ? (_openBlock(), _createBlock(AiButton, {
                          key: 0,
                          theme: "gradient-primary",
                          disabled: generationLoading.value,
                          onClick: removeBackgroundFileHandler,
                          class: "watremarks-edit__settings__button"
                        }, {
                          default: _withCtx(() => [
                            (!generationLoading.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('watremarks.watremarks')), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})